import { createPinia } from "pinia";
import { createApp } from "vue";
import AiNavigation from "./AiNavigation.vue";

function mountAiNavigation() {
  const mountId = "ai-navigation";
  const el = document.getElementById(mountId);
  if (!el) return;

  const props = window.vueProps?.[mountId] ?? {};
  const app = createApp(AiNavigation, props as unknown as Record<string, unknown>);
  app.use(createPinia());
  app.mount(`#${mountId}`);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountAiNavigation);
} else {
  mountAiNavigation();
}
